/* global axios */
import ApiClient from './ApiClient';

// Sante-CRM: funis de venda (Kanban odontológico)
class PipelinesAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  createStage(pipelineId, stageAttributes) {
    return axios.post(`${this.url}/${pipelineId}/pipeline_stages`, {
      pipeline_stage: stageAttributes,
    });
  }

  updateStage(pipelineId, stageId, stageAttributes) {
    return axios.patch(`${this.url}/${pipelineId}/pipeline_stages/${stageId}`, {
      pipeline_stage: stageAttributes,
    });
  }

  deleteStage(pipelineId, stageId) {
    return axios.delete(`${this.url}/${pipelineId}/pipeline_stages/${stageId}`);
  }
}

export default new PipelinesAPI();
